export default __webpack_public_path__ + "static/media/cv4.0cad5818.png";